import { render, staticRenderFns } from "./single-text-input-form.vue?vue&type=template&id=16875010&scoped=true"
import script from "./single-text-input-form.vue?vue&type=script&lang=js"
export * from "./single-text-input-form.vue?vue&type=script&lang=js"
import style0 from "./single-text-input-form.vue?vue&type=style&index=0&id=16875010&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16875010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16875010')) {
      api.createRecord('16875010', component.options)
    } else {
      api.reload('16875010', component.options)
    }
    module.hot.accept("./single-text-input-form.vue?vue&type=template&id=16875010&scoped=true", function () {
      api.rerender('16875010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/single-text-input-form.vue"
export default component.exports